import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthRole } from '../../features/auth/store/authSlice';
import { ROUTES } from '../../shared/config/routes';

export function RoleRoute({ children, allowedRoles }) {
  const role = useSelector(selectAuthRole);

  if (role === null) return null;

  if (!allowedRoles.includes(role)) {
    return <Navigate to={ROUTES.TEMPLATES} replace />;
  }

  return children;
}
